// feature/role-views — Admin · acción tardía approval queue (SPEC §11.3).
import React, { useEffect, useState } from "react";
import { admin, cases as casesApi } from "../../api/endpoints";
import Spinner from "../../components/Spinner";
import Empty from "../../components/Empty";
import Confirm from "../../components/Confirm";
import { TipoPill } from "../../components/Pills";
import { useToast } from "../../components/Toast";
import { useCaseLauncher } from "../../components/CaseLauncher";

const fmt = (d) => d ? new Date(d).toLocaleString("es-CO") : "—";
const fmtDay = (d) => d ? new Date(d).toLocaleDateString("es-CO") : "—";

export default function LateEntryQueue() {
  const toast = useToast();
  const launcher = useCaseLauncher();
  const [data, setData] = useState(null);
  const [rejectTarget, setRejectTarget] = useState(null);

  function load() {
    setData(null);
    admin.lateEntryQueue().then(r => setData(r.data)).catch(() => setData([]));
  }
  useEffect(() => { load(); }, []);

  async function approve(c) {
    try {
      await casesApi.approveLateEntry(c.id);
      toast.push(`Caso ${c.case_number} aprobado`);
      load();
    } catch (e) { toast.push(e?.response?.data?.error || "Error", "error"); }
  }
  async function doReject() {
    try {
      await casesApi.remove(rejectTarget.id);
      toast.push(`Caso ${rejectTarget.case_number} rechazado y eliminado`);
      setRejectTarget(null); load();
    } catch (e) { toast.push(e?.response?.data?.error || "Error", "error"); }
  }

  return (
    <div className="col" style={{ gap: 16 }}>
      <h1 style={{ margin: 0 }}>Registros extemporáneos</h1>
      <div className="muted" style={{ marginTop: -8 }}>
        Casos registrados de manera extemporánea. Mientras no estén aprobados, los abogados no pueden verlos.
      </div>

      <div className="card" style={{ padding: 0 }}>
        {data == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !data.length ? (
          <Empty title="No hay registros extemporáneos pendientes" />
        ) : (
          <table>
            <thead>
              <tr>
                <th>Caso</th><th>Tipo de actuación</th><th>Accionante</th>
                <th>Fecha real</th><th>Fecha de ingreso</th>
                <th>Creado por</th><th>Motivo / observaciones</th><th></th>
              </tr>
            </thead>
            <tbody>
              {data.map(c => (
                <tr key={c.id}>
                  <td onClick={() => launcher.open(c.id)} style={{ cursor: "pointer" }}><strong>{c.case_number}</strong></td>
                  <td><TipoPill tipo={c.tipo} /></td>
                  <td>{c.accionante_nombre || "—"}</td>
                  <td>{fmtDay(c.fecha_real_notificacion)}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{fmt(c.fecha_ingreso)}</td>
                  <td>{c.creado_por_name || "—"}</td>
                  <td style={{ maxWidth: 280, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={c.observaciones || ""}>
                    {c.observaciones || "—"}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <button className="sm" onClick={() => approve(c)}>Aprobar</button>
                    <button className="ghost sm" style={{ color: "var(--color-danger)" }} onClick={() => setRejectTarget(c)}>Rechazar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <Confirm
        open={!!rejectTarget}
        title="Rechazar registro extemporáneo"
        message={rejectTarget
          ? `${rejectTarget.case_number} se eliminará permanentemente. Esta acción no se puede deshacer.`
          : ""}
        onClose={() => setRejectTarget(null)}
        onConfirm={doReject}
        confirmText="Rechazar y eliminar"
        danger
      />
    </div>
  );
}
